var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('span',[_vm._l((_vm.content),function(item){return [_c('announcement-banner-content',_vm._b({key:item.text},'announcement-banner-content',item,false))]})],2):(_vm.link)?_c('a',{attrs:{"href":_vm.link.url,"target":_vm.link.external ? '_blank' : '_self'}},[_vm._v(_vm._s(_vm.text))]):_c('span',[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }